// Shared protocol-name recognition for Mail and its Admin configuration.
// Labels stay in locale files and are translated by the caller.
export type FolderNameKey =
  "inbox" | "sent" | "drafts" | "trash" | "junk" | "archive" | "outbox";

const aliases: Readonly<Record<string, FolderNameKey>> = {
  inbox: "inbox",
  posteingang: "inbox",
  sent: "sent",
  "sent items": "sent",
  "sent messages": "sent",
  gesendet: "sent",
  "sent mail": "sent",
  "gesendete objekte": "sent",
  "gesendete elemente": "sent",
  "gesendete nachrichten": "sent",
  drafts: "drafts",
  draft: "drafts",
  entwuerfe: "drafts",
  entwürfe: "drafts",
  trash: "trash",
  papierkorb: "trash",
  "deleted items": "trash",
  "deleted messages": "trash",
  bin: "trash",
  "gelöschte objekte": "trash",
  "gelöschte elemente": "trash",
  deleted: "trash",
  gelöscht: "trash",
  geloescht: "trash",
  junk: "junk",
  spam: "junk",
  "junk e-mail": "junk",
  "junk-e-mail": "junk",
  "junk email": "junk",
  "junk-mail": "junk",
  unerwünscht: "junk",
  unerwuenscht: "junk",
  archive: "archive",
  archiv: "archive",
  outbox: "outbox",
  postausgang: "outbox",
};

export function folderNameKey(name: string): FolderNameKey | undefined {
  const key = name.trim().toLowerCase();
  return Object.hasOwn(aliases, key) ? aliases[key] : undefined;
}
